// import * as Sentry from '@sentry/react';
// import { Integrations } from '@sentry/tracing';
import { createRoot } from 'react-dom/client';

import { App } from '@Components/App';
import { registerGlobalErrorReporting } from '@Utils/analytics/globalErrors';
import { proceedEventsBatchingWithInterval } from '@Utils/analytics/proceedEvents';

// Sentry.init({
//   dsn: 'https://773a573a0c46ec1046e3ba456c80c2a3@o4508318767841280.ingest.de.sentry.io/4508318931681360',
//   integrations: [new Integrations.BrowserTracing()],

//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 0.1,
// });

registerGlobalErrorReporting();
void proceedEventsBatchingWithInterval();

(() => {
  const container = document.getElementById('root');

  if (container) {
    const root = createRoot(container);
    root.render(<App />);
  }
})();
